package com.neurobs.ccabserver.administrator.view

import com.neurobs.js.view.{Container, Gui}
import com.neurobs.js.dom.{ButtonButton, Grid, HideableRowGrid, InputCheckBox, VideoElement}
import com.neurobs.js.dom.Grid._
import scalatags.JsDom.all._

class VideoChatView(gui: Gui) {
	import VideoChatView._
	import com.neurobs.js.dom.ElementFactory._
	import com.neurobs.js.dom.DOMViewElement._

	val commStatus: CommStatusView = new CommStatusView

	val examinerChat = new ExaminerChatView

	val powerStatus = new PowerStatusView(gui)

	val noiseMetrics = new NoiseMetricsView

	private val subjectVolume = input(`type` := "range", min := 0, max := 100, style := "width:8em;", value := 100).render
	def setSubjectVolumeVisible(visible: Boolean): Unit = rightGrid.setRowVisible(subjectVolume, visible)
	def setSubjectVolumeChangeHandler(handler: (Double) => Unit): Unit = {
		subjectVolume.onchange = { _ =>
			handler(subjectVolume.valueAsNumber)
		}
	}

	val subjectVideoCheckbox: InputCheckBox = makeCheckbox()
	private val subjectVideoContainer = span("Subject Video: ", subjectVideoCheckbox.input).render
	def setSubjectVideoVisible(visible: Boolean): Unit = rightGrid.setRowVisible(subjectVideoContainer, visible)

	val subjectAudioCheckbox: InputCheckBox = makeCheckbox()
	private val subjectAudioContainer = span("Subject Audio: ", subjectAudioCheckbox.input).render
	def setSubjectAudioVisible(visible: Boolean): Unit = rightGrid.setRowVisible(subjectAudioContainer, visible)

	val chatButton: ButtonButton = makeButton(caption = "Chat")
	def setChatButtonState(visible: Boolean, audioOnly: Boolean, enabled: Boolean): Unit = {
		rightGrid.setRowVisible(chatButton.button, visible)
		chatButton.setCaption(if (audioOnly) "Audio Chat" else "Chat")
		chatButton.setEnabled(enabled)
	}

	def setNoiseMetrics(metrics: Option[NoiseMetricsView.TestNoiseMetrics]): Unit = {
		noiseMetrics.set(metrics)
	}

	val upsizeButton: ButtonButton = makeButton(caption = "+", `class` = Some("video-chat-size-button"))
	val downsizeButton: ButtonButton = makeButton(caption = "-", `class` = Some("video-chat-size-button"))

	val endChatButton: ButtonButton = makeButton(caption = "End Chat")
	def setEndChatButtonVisible(visible: Boolean): Unit = rightGrid.setRowVisible(endChatButton.button, visible)

	val remoteVideo: VideoElement = new VideoElement(remoteVideoClass, initialWidthPixels = 300, initialHeightPixels = 300)
	val localVideo: VideoElement = new VideoElement(localVideoClass, initialWidthPixels = 0, initialHeightPixels = 0)
	val remoteAdminVideo: VideoElement = new VideoElement(localVideoClass, initialWidthPixels = 0, initialHeightPixels = 0)

	private val chatIndicator = div(`class` := chatIndicatorClass, div(`class` := chatIndicatorCircleClass)).render
	def setChatIndicatorVisible(visible: Boolean): Unit = rightGrid.setRowVisible(chatIndicator, visible)

	private val rightGrid: HideableRowGrid = {
		val grid = new HideableRowGrid(fullWidth = false, emGapSize, defaultAlign = Grid.alignCenter)

		grid.addRow(chatIndicator)
		grid.addRow(chatButton.button)
		grid.addRow(endChatButton.button)
		grid.addRow(subjectVideoContainer)
		grid.addRow(subjectAudioContainer)
		grid.addRow(commStatus.container)
		grid.addRow(subjectVolume)
		grid.addRow(powerStatus.container)
		grid.addRow(noiseMetrics.container)
		grid
	}

	val container: Container = {
		val resizeColumn = new Grid(fullWidth = false, emGapSize = emGapSize / 2)
		resizeColumn.addRow(downsizeButton.button)
		resizeColumn.addRow(upsizeButton.button)

		val grid = new Grid(fullWidth = false, emGapSize = emGapSize)
		grid.addRowCells(List(resizeColumn.container, remoteVideo.element, rightGrid.container, div(localVideo.element, remoteAdminVideo.element).render, toElement(examinerChat.container)))

		div(`class` := videoContainerClass, grid.container).render
	}
}

object VideoChatView {
	private val remoteVideoClass = "video-chat-remote-video"
	private val localVideoClass = "video-chat-local-video"
	private val videoContainerClass = "video-chat-video-container"
	private val chatIndicatorClass = "video-chat-chat-indicator"
	private val chatIndicatorCircleClass = "video-chat-chat-indicator-circle"
	private val emGapSize: Double = 1
}
